import "core-js/modules/es.array.filter";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import { showErrors, showNotification } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppCheckbox from '@/components/AppCheckbox.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppTextarea from '@/components/AppTextarea.vue';
import ListPage from '@/mixins/list-page';
import { DealersOrderBy } from '@/interfaces/dealer';
import { exportDealersList, findDealers } from './gql';
import DealerDialog from './script-dialog';
import AuthFilter from '@/mixins/auth-filter';
import { SnackType } from '@/interfaces/snack';
import { downloadBase64 } from '@/helpers/base64-to-file';

var DealerList = /*#__PURE__*/function (_mixins) {
  _inherits(DealerList, _mixins);

  var _super = _createSuper(DealerList);

  function DealerList() {
    var _this;

    _classCallCheck(this, DealerList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '经销商管理'
    }, {
      text: '经销商'
    }];
    _this.options = {
      sortBy: ['realname'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.filter = {
      area: null,
      name: '',
      phone: '',
      statusIndex: -1
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.disableConfirm = false;
    _this.headers = [{
      text: '姓名',
      value: 'realname'
    }, {
      text: '手机号(经销商登录账号)',
      value: 'user.phone'
    }, {
      text: '申请区域',
      value: 'areas[0].mergerName'
    }, {
      text: '店铺名称',
      value: 'storeName'
    }, {
      text: '审核时间',
      value: 'auditDate'
    }, {
      text: '申请时间',
      value: 'applyDate'
    }, {
      text: '状态',
      value: 'status'
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.disabledActions = true;
    _this.dealers = [];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.selectedDealers = [];
    _this.actionsHeight = 51;
    return _this;
  }

  _createClass(DealerList, [{
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getDealers();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.getRole() === 'dealer') {
        this.headers.pop();
      }

      this.onResize();
      this.restorePage(this.cache);
      this.getDealers();
    }
  }, {
    key: "refreshList",
    value: function () {
      var _refreshList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.filter = {
                  area: null,
                  name: '',
                  phone: '',
                  statusIndex: -1
                };
                this.getDealers();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshList() {
        return _refreshList.apply(this, arguments);
      }

      return refreshList;
    }()
  }, {
    key: "getDealers",
    value: function () {
      var _getDealers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, name, phone, statusIndex, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, name = _this$filter.name, phone = _this$filter.phone, statusIndex = _this$filter.statusIndex;
                by = DealersOrderBy[sortBy[0] || 'realname'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  realname: name || null,
                  phone_OF_user: phone || null,
                  status_EQ: this.auditCodes[statusIndex] || null
                };
                _context2.next = 10;
                return this.queryDealersRequest(order, paging, where);

              case 10:
                result = _context2.sent;

                if (result) {
                  this.dealers = result.dealers;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getDealers() {
        return _getDealers.apply(this, arguments);
      }

      return getDealers;
    }()
  }, {
    key: "queryDealersRequest",
    value: function () {
      var _queryDealersRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findDealers,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findDealers);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function queryDealersRequest(_x, _x2, _x3) {
        return _queryDealersRequest.apply(this, arguments);
      }

      return queryDealersRequest;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function () {
      var _filterQuerySubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getDealers();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function filterQuerySubmit() {
        return _filterQuerySubmit.apply(this, arguments);
      }

      return filterQuerySubmit;
    }()
  }, {
    key: "deleteConfirm",
    value: function () {
      var _deleteConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.deleteDealerById();

              case 2:
                _context5.next = 4;
                return this.getDealers();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteConfirm() {
        return _deleteConfirm.apply(this, arguments);
      }

      return deleteConfirm;
    }()
  }, {
    key: "auditConfirm",
    value: function () {
      var _auditConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.auditDialog.show = false;
                _context6.t0 = this.auditIndex;
                _context6.next = _context6.t0 === 0 ? 4 : _context6.t0 === 1 ? 8 : 10;
                break;

              case 4:
                _context6.next = 6;
                return this.auditDealer(this.AuditStatus.APPROVED);

              case 6:
                this.getDealers();
                return _context6.abrupt("break", 10);

              case 8:
                this.denyDialog.show = true;
                return _context6.abrupt("break", 10);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function auditConfirm() {
        return _auditConfirm.apply(this, arguments);
      }

      return auditConfirm;
    }()
  }, {
    key: "denyConfirm",
    value: function () {
      var _denyConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.auditDealer(this.AuditStatus.REJECT);

              case 2:
                this.denyDialog.show = false;
                this.getDealers();

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function denyConfirm() {
        return _denyConfirm.apply(this, arguments);
      }

      return denyConfirm;
    }()
  }, {
    key: "routeToDetail",
    value: function routeToDetail(item) {
      this.targetDealer = item;
      this.$router.push({
        name: 'DealerDetail',
        params: {
          id: item.id + '',
          name: item.realname
        }
      });
    }
  }, {
    key: "auditStatus",
    value: function auditStatus(status) {
      return {
        'u-tag-red': status === 'REJECT',
        'u-tag-orange': status === 'PENDING',
        'u-tag-blue': status === 'APPROVED'
      };
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this$options2, sortBy, sortDesc, _this$filter2, name, phone, statusIndex, by, asc, order, where, result, _result$data$exportDe, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, name = _this$filter2.name, phone = _this$filter2.phone, statusIndex = _this$filter2.statusIndex;
                by = DealersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  realname: name || null,
                  phone_OF_user: phone || null,
                  status_EQ: this.auditCodes[statusIndex] || null
                };
                _context8.prev = 8;
                _context8.next = 11;
                return this.$apollo.query({
                  query: exportDealersList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context8.sent;

                if (result.data) {
                  _result$data$exportDe = result.data.exportDealersList, fileName = _result$data$exportDe.fileName, contentB64 = _result$data$exportDe.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](8);
                typedError = _context8.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }]);

  return DealerList;
}(mixins(DealerDialog, ListPage, AuthFilter));

__decorate([State(function (state) {
  return state.page.DealerList;
})], DealerList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], DealerList.prototype, "onOptionsChanged", null);

DealerList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppCheckbox: AppCheckbox,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppSearchBtn: AppSearchBtn,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppTextarea: AppTextarea
  }
})], DealerList);
export default DealerList;